import React, { useState, useEffect } from 'react';

const useDebouncedValue = <T>(
    initialValue: T,
    time: number,
    debouncedValueChange?: (debouncedValue: T) => void
): [T, T, React.Dispatch<T>, React.Dispatch<T>] => {
    const [value, setValue] = useState<T>(initialValue);
    const [debouncedValue, setDebouncedValue] = useState<T>(initialValue);

    useEffect(() => {
        const debounce = setTimeout(() => {
            setDebouncedValue(value);
            debouncedValueChange && debouncedValueChange(value);
        }, time);
        return () => {
            clearTimeout(debounce);
        };
    }, [value, time]);

    return [value, debouncedValue, setValue, setDebouncedValue];
};

export default useDebouncedValue;
